export enum Level {
    UNKNOWN,
    FLEET,
    VESSEL,
}
